const checklists = [
    {
        uuid:'1',
        release:'1.0',
        description:'說明.......',
        activatedOn:'2021-11-01T00:00:00.000Z',
        expiredOn:'2021-11-30T00:00:00.000Z',
        createdOn:'2021-11-01T00:00:00.000Z',
        creator:'陳育豪',
        detail : [
            {
                code:'01',text:'1.一般資料',display:'一般資料',
                items:[
                    {code:'01-1',itemSeq:'1-1', text:'1.1 該客戶是否擁有“里仁食品委託評鑑作業細則”或“慈悅評鑑作業細則”？',"guide":"請填客戶擁有的標準版次"},
                    {code:'01-2',itemSeq:'1-2', text:'1.2 該客戶對於前項評鑑作業細則之內容是否清楚了解？'},
                    {code:'01-3',itemSeq:'1-3', text:'1.3 查驗過程中，受訪人是否全程在場？',"guide":"請填當天陪同人員名字與職稱", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"]},
                    {code:'01-4',itemSeq:'1-4', text:'1.4 客戶與評鑑場所之基本資料是否符合現況？',"guide":"1.核對客戶營登資料與評鑑場所資訊是否與政府公示資料一致\n" +
                            "2.核對實際評鑑場所地址是否與申請資料一致\n" +
                            "◎查詢網址:\n" +
                            "1.https://findbiz.nat.gov.tw/fts/query/QueryBar/queryInit.do(公司.商業.工廠)\n" +
                            "2.https://www.etax.nat.gov.tw/etwmain/web/ETW113W1_2(個人戶)",regulations:["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'01-others',itemSeq:'1-其他', text:'1.5 其他說明'},
                ]
            },
            {
                code:'02',text:'2.廠區環境',display:'廠區環境',
                items:[
                    {code:'02-1',itemSeq:'2-1', text:'2.1 廠外環境污染源現況與申請資料描述一致？（農田農藥、化工廠、垃圾堆積場……）', regulations: ["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'02-2',itemSeq:'2-2', text:'2.2 與污染源是否距離15公尺以上？若否請說明其污染防治措施',regulations:["里仁細則6.2.1","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'02-3',itemSeq:'2-3', text:'2.3 廠區鄰近及廠內道路清潔？',"regulations":["GHP附表一.一.(一)"]},
                    {code:'02-4',itemSeq:'2-4', text:'2.4 廠區附近禽畜、寵物有適當管制措施，以免污染食品？',"regulations":["GHP附表一.一.(三)"]},
                    {code:'02-others',itemSeq:'2-其他', text:'2.5 其他說明'},
                ]
            },
            {
                code:'03',text:'3.廠房與設施', display: '廠房與設施',
                items:[
                    {code:'03-1',itemSeq:'3-1', text:'3.1 客戶提供之評鑑場所平面圖與實際看到者是否一致？',"guide":"1.生產流程是否有在其他廠區生產未列出\n" +
                            "2.工廠平面配置是否有異動、是否有新增產線\n" +
                            "3.同一廠址及廠房是否同時從事非食品之製造、加工及調配",
                        "regulations":["食安法第十條(食品工廠建築及設備設廠標準107/ 9/27衛授食字第 1071301538 號令會銜修正)","里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'03-2',itemSeq:'3-2', text:'3.2 廠房建築與申請資料一致?',observationDefault:"水泥磚造、木材、鐵皮、其他","regulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'03-3',itemSeq:'3-3', text:'3.3 食品作業場所之樓板及天花板清潔，無長黴、剝落、積塵、納垢、結露等現象？',"regulations":["GHP附表一.二.(二)"]},
                    {code:'03-4',itemSeq:'3-4', text:'3.4 食品作業場所之牆壁、支柱及地面清潔，無納垢、剝落、侵蝕、積水等現象？'},
                    {code:'03-5',itemSeq:'3-5', text:'3.5 廠房之排水系統暢通？'},
                    {code:'03-6',itemSeq:'3-6', text:'3.6 廠房光源不會改變食品原本的顏色？ 照明設備光線足夠且保持清潔？'},
                    {code:'03-7',itemSeq:'3-7', text:'3.7 廁所未正面開向食品作業場所？但有緩衝設施及有效控制空氣流向防止汙染者不在此限。'},
                    {code:'03-8',itemSeq:'3-8', text:'3.8 廁所保持清潔？'},
                    {code:'03-9',itemSeq:'3-9', text:'3.9 廁所在明顯處標示“如廁後應洗手”之字樣？'},
                    {code:'03-10',itemSeq:'3-10', text:'3.10 作業場所洗手設施有標示簡明、易懂之洗手方法？'},
                    {code:'03-11',itemSeq:'3-11', text:'3.11 作業場所洗手及乾手設備設置地點適當且數目足夠?必要時，應設置消毒設施'},
                    {code:'03-12',itemSeq:'3-12', text:'3.12 作業場所洗手消毒設施之設計可防止清洗後手部再度遭受污染？'},
                    {code:'03-13',itemSeq:'3-13', text:'3.13 凡清潔度要求不同之作業場所加以有效區隔與管理，並保持整潔，以避免污染？'},
                    {code:'03-others',itemSeq:'3-其他', text:'3.14 其他說明'},
                ]
            },
            {
                code:'04',text:'4.工作場所衛生管理', display: '工作場所衛生管理',
                items:[
                    {code:'04-1',itemSeq:'4-1', text:'4.1 各作業場所通風良好無不良氣味？'},
                    {code:'04-2',itemSeq:'4-2', text:'4.2 放置廢棄物之設施不會成為病媒孳長、棲息處所或提供其食物來源？請說明各種廢棄物之處理方式與清運頻率'},
                    {code:'04-3',itemSeq:'4-3', text:'4.3 食品作業場所內未堆放廢棄物或垃圾？'},
                    {code:'04-4',itemSeq:'4-4', text:'4.4 出入口、門窗、通風口、排水系統及其他孔道保持清潔，並設置防止病媒侵入之設施？'},
                    {code:'04-5',itemSeq:'4-5', text:'4.5 工作場所實施有效之病媒防治措施？若否，請敘述觀察到那些病媒蹤跡？'},
                    {code:'04-6',itemSeq:'4-6', text:'4.6 病媒防治使用之環境用藥符合環境用藥管理法及其相關法規之規定，並明確標示，存放於固定場所，且專人負責保管及記錄其用量？\n' +
                            '請紀錄施藥單位(病媒防治公司名稱/許可執照字號)，藥劑名稱/許可證字號，施藥區域，施藥頻率，及如何防範污染原料.產品.包材等\n'},
                    {code:'04-7',itemSeq:'4-7', text:'4.7 與食品接觸面的設備、器皿保持清潔平滑、無凹陷或裂縫？'},
                    {code:'04-8',itemSeq:'4-8', text:'4.8 加工、包裝之設備、器具、容器及管線等於使用前後清洗乾淨或消毒？請敘述以何清潔、消毒洗劑清洗？'},
                    {code:'04-9',itemSeq:'4-9', text:'4.9 清洗消毒作業不會污染食品或食品接觸面'},
                    {code:'04-10',itemSeq:'4-10', text:'4.10 食品用洗潔劑符合食品用洗潔劑衛生標準'},
                    {code:'04-11',itemSeq:'4-11', text:'4.11 盛裝清潔、消毒洗劑等之容器有作明確之標示？指定專人負責保管及記錄其用量?'},
                    {code:'04-12',itemSeq:'4-12', text:'4.12 食品接觸面使用後不再經清水沖洗或用於清洗食品者，使用濃度或殘留濃度符合規定?與申請資料一致?'},
                    {code:'04-13',itemSeq:'4-13', text:'4.13 清潔劑、消毒劑、清掃用機具有固定場所作妥善保存？'},
                    {code:'04-14',itemSeq:'4-14', text:'4.14 作業場所未放置非工作所需之其他雜物？'},
                    {code:'04-15',itemSeq:'4-15', text:'4.15 未使用聚氯乙烯(PVC)或聚偏二氯乙烯(PVDC)材質之塑膠器具容器包裝或耗材？如否，請說明用於何處？如何預防產品受塑化劑污染？'},
                    {code:'04-16',itemSeq:'4-16', text:'4.16 指派管理衛生人員，就建築與設施及衛生管理情形，按日填報衛生管理紀錄？'},
                    {code:'04-others',itemSeq:'4-其他', text:'4.17 其他說明'},
                ]
            },
            {
                code:'05',text:'5.人員衛生', display: '人員衛生',
                items:[
                    {code:'05-1',itemSeq:'5-1', text:'5.1 食品從業人員有穿戴整潔之工作衣帽(鞋)，必要時戴口罩？'},
                    {code:'05-2',itemSeq:'5-2', text:'5.2 食品從業人員手部未留長指甲或穿戴手飾？'},
                    {code:'05-3',itemSeq:'5-3', text:'5.3 食品從業人員於進入食品作業場所前、如廁後或手部受汙染時，依正確步驟洗手或(及)消毒。'},
                    {code:'05-4',itemSeq:'5-4', text:'5.4 調理不經加熱即食的食品穿戴清潔不透水手套，或將手部徹底洗淨及消毒？'},
                    {code:'05-5',itemSeq:'5-5', text:'5.5 工作中未有吸煙、飲食、嚼口香糖等不當行為？'},
                    {code:'05-6',itemSeq:'5-6', text:'5.6 與食品直接接觸的食品從業人員每年接受健康檢查（例：法規要求之項目如A型肝炎IgM、肺結核…）？'},
                    {code:'05-7',itemSeq:'5-7', text:'5.7 食品從業人員患有傳染病、手部皮膚病、外傷時，未從事與食品接觸的工作？'},
                    {code:'05-8',itemSeq:'5-8', text:'5.8 食品從業人員定期接受食品安全、衛生與品質管理之講習或訓練，並作成紀錄？'},
                    {code:'05-9',itemSeq:'5-9', text:'5.9 非食品從業人員出入管制作業區時，有作符合現場工作人員衛生要求之管理？'},
                    {code:'05-others',itemSeq:'5-其他', text:'5.10 其他說明'},
                ]
            },
            {
                code:'06',text:'6.原料', display: '原料',
                items:[
                    {code:'06-1',itemSeq:'6-1', text:'6.1 原料相關證明文件或檢驗報告可與使用原料來源勾稽，檢驗數值符合相關規定且有效期的證書未過期？'},
                    {code:'06-2',itemSeq:'6-2', text:'6.2 採用之原料與原料明細表所提供之資料符合？請說明任何異動部份'},
                    {code:'06-3',itemSeq:'6-3', text:'6.3 原材料進貨時有驗收紀錄？驗收不合格者，有明確標示，避免誤用?'},
                    {code:'06-4',itemSeq:'6-4', text:'6.4 原料分類.離地.通風.整潔.密封放置？'},
                    {code:'06-5',itemSeq:'6-5', text:'6.5 原料依先進先出之原則處理？積存的原料未超過使用期限？生鮮原料新鮮未腐爛發霉？'},
                    {code:'06-6',itemSeq:'6-6', text:'6.6 原料各溫層儲存方式符合管控標準，並記錄?且冷凍(藏)庫未結霜?'},
                    {code:'06-7',itemSeq:'6-7', text:'6.7 製程用水水源（包含與食品直接接觸及清洗食品設備、用具之用水及冰塊）是否與申請資料描述相同？'},
                    {code:'06-8',itemSeq:'6-8', text:'6.8 製程用水之淨水處理符合規定？請說明'},
                    {code:'06-9',itemSeq:'6-9', text:'6.9 製程用水是否符合飲用水水質標準？'},
                    {code:'06-10',itemSeq:'6-10', text:'6.10 製程用水非使用自來水者，每日作有效餘氯量及酸鹼值之測定？並檢送經環保署許可之檢驗機構檢驗(微生物每年，6項重金屬兩年一次)？其測定值為何？'},
                    {code:'06-11',itemSeq:'6-11', text:'6.11 雜用水與申請資料描述相同？'},
                    {code:'06-12',itemSeq:'6-12', text:'6.12 製程用水與雜用水之管路完全分離？有做明顯標示區分？'},
                    {code:'06-13',itemSeq:'6-13', text:'6.13 使用地下水者，水源與化糞池、廢棄物、堆積場等污染源距離至少15公尺以上？'},
                    {code:'06-14',itemSeq:'6-14', text:'6.14 蓄水池（塔、槽）設置地點與化糞池、廢棄物、堆積場等污染源距離3公尺以上？'},
                    {code:'06-15',itemSeq:'6-15', text:'6.15 蓄水池（塔、槽）每年至少清洗一次並記錄？'},
                    {code:'06-16',itemSeq:'6-16', text:'6.16 使用之添加物有食品添加物許可字號或食品業者登錄平台之「產品登錄碼」？ '},
                    {code:'06-17',itemSeq:'6-17', text:'6.17 食品添加物有專櫃儲放、專人管理及專冊登錄使用？'},
                    {code:'06-18',itemSeq:'6-18', text:'6.18 食品添加物之使用符合使用範圍及限量之規定?秤量及投料有重複檢核並記錄?如有使用上限之食品添加物，請寫出該使用比例？【(該添加物重量/總原料重量)×100】'},
                    {code:'06-19',itemSeq:'6-19', text:'6.19 評鑑產品所用之原料皆有核對且與原料明細表相符?若未核對到所有原料，請說明未核對之產品名稱與原料名稱(新申請查驗與增列查驗適用)'},
                    {code:'06-others',itemSeq:'6-其他', text:'6.20 其他說明'},
                ]
            },
            {
                code:'07',text:'7.製程管理',display: '製程管理',
                items:[
                    {code:'07-1',itemSeq:'7-1', text:'7.1 實際製程與客戶所提供之資料一致？請說明任何異動部份'},
                    {code:'07-2',itemSeq:'7-2', text:'7.2 食品在製程中（含設備、器具、容器），未與地面直接接觸？'},
                    {code:'07-3',itemSeq:'7-3', text:'7.3 採取有效措施以防止金屬或外來雜物混入食品中？'},
                    {code:'07-4',itemSeq:'7-4', text:'7.4 油炸產品於製程中管控油炸用食用油之總極性化合物？請說明管理方式與檢測結果'},
                    {code:'07-5',itemSeq:'7-5', text:'7.5 於製程中有相關之管制標準？且符合管控標準？（例如：溫度、濕度、pH、水活性……）請說明管制項目、管制標準、管制結果為何？'},
                    {code:'07-6',itemSeq:'7-6', text:'7.6 測定、控制或記錄之量測器或記錄儀，應定期校正其準確性。'},
                    {code:'07-7',itemSeq:'7-7', text:'7.7 如屬於低酸性真空包裝即食性黃豆產品、低酸性及酸化罐頭食品者，其殺菌條件記錄符合中央主管機關認可機構評估之管控標準？'},
                    {code:'07-8',itemSeq:'7-8', text:'7.8 製程及品質管制有異常現象時，有矯正及防止再發生之改善措施紀錄？'},
                    {code:'07-others',itemSeq:'7-其他', text:'7.9 其他說明'},
                ]
            },
            {
                code:'08',text:'8.產品',display: '產品',
                items:[
                    {code:'08-1',itemSeq:'8-1', text:'8.1 不得回收使用之器具、容器及包裝未重複使用，得回收再使用者有經適當清潔、消毒？'},
                    {code:'08-2',itemSeq:'8-2', text:'8.2 包裝方式與包裝材質與申請資料描述相同？有符合食品器具容器包裝衛生標準之報告？'},
                    {code:'08-3',itemSeq:'8-3', text:'8.3 產品標示符合申請資料且屬實?(成分、訴求成分含量、保存方式、保存期限、原料來源宣稱..等)'},
                    {code:'08-4',itemSeq:'8-4', text:'8.4 產品標示之有效日期符合制定之保存期限？無標示不實或無未來商品？'},
                    {code:'08-5',itemSeq:'8-5', text:'8.5 品名標示原則有成分含量限制者，核對投料記錄是否符合法規規範？如：全麥麵、米粉、巧克力'},
                    {code:'08-6',itemSeq:'8-6', text:'8.6 如為自然發酵之產品，酒精含量檢測結果符合規定？檢測單位與檢測數據為何？'},
                    {code:'08-7',itemSeq:'8-7', text:'8.7 產品檢驗報告符合產品規格表？檢測項目與檢測值為何？'},
                    {code:'08-8',itemSeq:'8-8', text:'8.8 產品分類.離地.通風.整潔放置？'},
                    {code:'08-9',itemSeq:'8-9', text:'8.9 成品、半成品與原料倉庫分別設置或有作適當之區隔，能防止交叉汙染？'},
                    {code:'08-10',itemSeq:'8-10', text:'8.10 產品不合格者有加以適當處理、區隔、標示？'},
                    {code:'08-11',itemSeq:'8-11', text:'8.11 產品各溫層儲存方式符合管控標準，並記錄?冷凍(藏)庫未結霜?'},
                    {code:'08-12',itemSeq:'8-12', text:'8.12 產品有依照先進先出的原則出貨？'},
                    {code:'08-13',itemSeq:'8-13', text:'8.13 成品是否留樣保存至有效日期？'},
                    {code:'08-14',itemSeq:'8-14', text:'8.14 運輸車輛是否有運輸紀錄(車輛清潔度、車溫...)？'},
                    {code:'08-15',itemSeq:'8-15', text:'8.15 應建立產品原材料、半成品與成品供應來源及流向之追溯或追蹤系統，包含原材料進貨單/驗收單、領用/配料/投料紀錄、製程管制記錄(生產紀錄)、產品檢驗紀錄、產品入庫紀錄、產品出貨/配送記錄...等應有批號紀錄。【查驗若非單批(不同批接力)全流程查驗者，須同時確認是否達進出平衡】'},
                    {code:'08-16',itemSeq:'8-16', text:'8.16 無過去三年內（含）未曾生產之評鑑產品? 若有，請列出產品名稱，以做為延續該產品評鑑資格之參考依據。(展延查驗才須確認)'},
                    {code:'08-others',itemSeq:'8-其他', text:'8.17 其他說明'},
                ]
            },
            {
                code:'09',text:'9.標章使用', display: '標章使用',
                items:[
                    {code:'09-1',itemSeq:'9-1', text:'9.1 損毀及廢棄標章之處理方式是否予以文件化並做成紀錄?'},
                    {code:'09-2',itemSeq:'9-1', text:'9.2 是否正確使用潔淨、雙潔淨、100%無添加之標章？ '},
                    {code:'09-others',itemSeq:'9-其他', text:'9.3 其他說明'},
                ]
            },
        ]
    },{
        uuid:'2',
        release:'2.0',
        description:'說明......',
        activatedOn:'2021-12-01T00:00:00.000Z',
        expiredOn:'2021-12-31T00:00:00.000Z',
        createdOn:'2021-12-01T00:00:00.000Z',
        creator:'陳育豪',
        detail : [
            {
                code:'01',text:'1.一般資料',display:'一般資料',
                items:[
                    {code:'01-1',itemSeq:'1-1', text:'1.1 該客戶是否擁有“里仁食品委託評鑑作業細則”或“慈悅評鑑作業細則”？',"guide":"請填客戶擁有的標準版次"},
                    {code:'01-2',itemSeq:'1-2', text:'1.2 該客戶對於前項評鑑作業細則之內容是否清楚了解？'},
                    {code:'01-3',itemSeq:'1-3', text:'1.3 查驗過程中，受訪人是否全程在場？',"guide":"請填當天陪同人員名字與職稱", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"]},
                    {code:'01-4',itemSeq:'1-4', text:'1.4 客戶與評鑑場所之基本資料是否符合現況？',"guide":"1.核對客戶營登資料與評鑑場所資訊是否與政府公示資料一致\n" +
                            "2.核對實際評鑑場所地址是否與申請資料一致\n" +
                            "◎查詢網址:\n" +
                            "1.https://findbiz.nat.gov.tw/fts/query/QueryBar/queryInit.do(公司.商業.工廠)\n" +
                            "2.https://www.etax.nat.gov.tw/etwmain/web/ETW113W1_2(個人戶)",regulations:["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'01-others',itemSeq:'1-其他', text:'1.5 其他說明'},
                ]
            },
            {
                code:'02',text:'2.廠區環境',display:'廠區環境',
                items:[
                    {code:'02-1',itemSeq:'2-1', text:'2.1 廠外環境污染源現況與申請資料描述一致？（農田農藥、化工廠、垃圾堆積場……）', regulations: ["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'02-2',itemSeq:'2-2', text:'2.2 與污染源是否距離15公尺以上？若否請說明其污染防治措施',regulations:["里仁細則6.2.1","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'02-3',itemSeq:'2-3', text:'2.3 廠區鄰近及廠內道路清潔？',"regulations":["GHP附表一.一.(一)"]},
                    {code:'02-4',itemSeq:'2-4', text:'2.4 廠區附近禽畜、寵物有適當管制措施，以免污染食品？',"regulations":["GHP附表一.一.(三)"]},
                    {code:'02-others',itemSeq:'2-其他', text:'2.5 其他說明'},
                ]
            },
            {
                code:'03',text:'3.廠房與設施', display: '廠房與設施',
                items:[
                    {code:'03-1',itemSeq:'3-1', text:'3.1 客戶提供之評鑑場所平面圖與實際看到者是否一致？',"guide":"1.生產流程是否有在其他廠區生產未列出\n" +
                            "2.工廠平面配置是否有異動、是否有新增產線\n" +
                            "3.同一廠址及廠房是否同時從事非食品之製造、加工及調配",
                        "regulations":["食安法第十條(食品工廠建築及設備設廠標準107/ 9/27衛授食字第 1071301538 號令會銜修正)","里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'03-2',itemSeq:'3-2', text:'3.2 廠房建築與申請資料一致?',observationDefault:"水泥磚造、木材、鐵皮、其他","regulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"]},
                    {code:'03-3',itemSeq:'3-3', text:'3.3 食品作業場所之樓板及天花板清潔，無長黴、剝落、積塵、納垢、結露等現象？',"regulations":["GHP附表一.二.(二)"]},
                    {code:'03-4',itemSeq:'3-4', text:'3.4 食品作業場所之牆壁、支柱及地面清潔，無納垢、剝落、侵蝕、積水等現象？'},
                    {code:'03-5',itemSeq:'3-5', text:'3.5 廠房之排水系統暢通？'},
                    {code:'03-6',itemSeq:'3-6', text:'3.6 廠房光源不會改變食品原本的顏色？ 照明設備光線足夠且保持清潔？'},
                    {code:'03-7',itemSeq:'3-7', text:'3.7 廁所未正面開向食品作業場所？但有緩衝設施及有效控制空氣流向防止汙染者不在此限。'},
                    {code:'03-8',itemSeq:'3-8', text:'3.8 廁所保持清潔？'},
                    {code:'03-9',itemSeq:'3-9', text:'3.9 廁所在明顯處標示“如廁後應洗手”之字樣？'},
                    {code:'03-10',itemSeq:'3-10', text:'3.10 作業場所洗手設施有標示簡明、易懂之洗手方法？'},
                    {code:'03-11',itemSeq:'3-11', text:'3.11 作業場所洗手及乾手設備設置地點適當且數目足夠?必要時，應設置消毒設施'},
                    {code:'03-12',itemSeq:'3-12', text:'3.12 作業場所洗手消毒設施之設計可防止清洗後手部再度遭受污染？'},
                    {code:'03-13',itemSeq:'3-13', text:'3.13 凡清潔度要求不同之作業場所加以有效區隔與管理，並保持整潔，以避免污染？'},
                    {code:'03-others',itemSeq:'3-其他', text:'3.14 其他說明'},
                ]
            },
            {
                code:'04',text:'4.工作場所衛生管理', display: '工作場所衛生管理',
                items:[
                    {code:'04-1',itemSeq:'4-1', text:'4.1 各作業場所通風良好無不良氣味？'},
                    {code:'04-2',itemSeq:'4-2', text:'4.2 放置廢棄物之設施不會成為病媒孳長、棲息處所或提供其食物來源？請說明各種廢棄物之處理方式與清運頻率'},
                    {code:'04-3',itemSeq:'4-3', text:'4.3 食品作業場所內未堆放廢棄物或垃圾？'},
                    {code:'04-4',itemSeq:'4-4', text:'4.4 出入口、門窗、通風口、排水系統及其他孔道保持清潔，並設置防止病媒侵入之設施？'},
                    {code:'04-5',itemSeq:'4-5', text:'4.5 工作場所實施有效之病媒防治措施？若否，請敘述觀察到那些病媒蹤跡？'},
                    {code:'04-6',itemSeq:'4-6', text:'4.6 病媒防治使用之環境用藥符合環境用藥管理法及其相關法規之規定，並明確標示，存放於固定場所，且專人負責保管及記錄其用量？\n' +
                            '請紀錄施藥單位(病媒防治公司名稱/許可執照字號)，藥劑名稱/許可證字號，施藥區域，施藥頻率，及如何防範污染原料.產品.包材等\n'},
                    {code:'04-7',itemSeq:'4-7', text:'4.7 與食品接觸面的設備、器皿保持清潔平滑、無凹陷或裂縫？'},
                    {code:'04-8',itemSeq:'4-8', text:'4.8 加工、包裝之設備、器具、容器及管線等於使用前後清洗乾淨或消毒？請敘述以何清潔、消毒洗劑清洗？'},
                    {code:'04-9',itemSeq:'4-9', text:'4.9 清洗消毒作業不會污染食品或食品接觸面'},
                    {code:'04-10',itemSeq:'4-10', text:'4.10 食品用洗潔劑符合食品用洗潔劑衛生標準'},
                    {code:'04-11',itemSeq:'4-11', text:'4.11 盛裝清潔、消毒洗劑等之容器有作明確之標示？指定專人負責保管及記錄其用量?'},
                    {code:'04-12',itemSeq:'4-12', text:'4.12 食品接觸面使用後不再經清水沖洗或用於清洗食品者，使用濃度或殘留濃度符合規定?與申請資料一致?'},
                    {code:'04-13',itemSeq:'4-13', text:'4.13 清潔劑、消毒劑、清掃用機具有固定場所作妥善保存？'},
                    {code:'04-14',itemSeq:'4-14', text:'4.14 作業場所未放置非工作所需之其他雜物？'},
                    {code:'04-15',itemSeq:'4-15', text:'4.15 未使用聚氯乙烯(PVC)或聚偏二氯乙烯(PVDC)材質之塑膠器具容器包裝或耗材？如否，請說明用於何處？如何預防產品受塑化劑污染？'},
                    {code:'04-16',itemSeq:'4-16', text:'4.16 指派管理衛生人員，就建築與設施及衛生管理情形，按日填報衛生管理紀錄？'},
                    {code:'04-others',itemSeq:'4-其他', text:'4.17 其他說明'},
                ]
            },
            {
                code:'05',text:'5.人員衛生', display: '人員衛生',
                items:[
                    {code:'05-1',itemSeq:'5-1', text:'5.1 食品從業人員有穿戴整潔之工作衣帽(鞋)，必要時戴口罩？'},
                    {code:'05-2',itemSeq:'5-2', text:'5.2 食品從業人員手部未留長指甲或穿戴手飾？'},
                    {code:'05-3',itemSeq:'5-3', text:'5.3 食品從業人員於進入食品作業場所前、如廁後或手部受汙染時，依正確步驟洗手或(及)消毒。'},
                    {code:'05-4',itemSeq:'5-4', text:'5.4 調理不經加熱即食的食品穿戴清潔不透水手套，或將手部徹底洗淨及消毒？'},
                    {code:'05-5',itemSeq:'5-5', text:'5.5 工作中未有吸煙、飲食、嚼口香糖等不當行為？'},
                    {code:'05-6',itemSeq:'5-6', text:'5.6 與食品直接接觸的食品從業人員每年接受健康檢查（例：法規要求之項目如A型肝炎IgM、肺結核…）？'},
                    {code:'05-7',itemSeq:'5-7', text:'5.7 食品從業人員患有傳染病、手部皮膚病、外傷時，未從事與食品接觸的工作？'},
                    {code:'05-8',itemSeq:'5-8', text:'5.8 食品從業人員定期接受食品安全、衛生與品質管理之講習或訓練，並作成紀錄？'},
                    {code:'05-9',itemSeq:'5-9', text:'5.9 非食品從業人員出入管制作業區時，有作符合現場工作人員衛生要求之管理？'},
                    {code:'05-others',itemSeq:'5-其他', text:'5.10 其他說明'},
                ]
            },
            {
                code:'06',text:'6.原料', display: '原料',
                items:[
                    {code:'06-1',itemSeq:'6-1', text:'6.1 原料相關證明文件或檢驗報告可與使用原料來源勾稽，檢驗數值符合相關規定且有效期的證書未過期？'},
                    {code:'06-2',itemSeq:'6-2', text:'6.2 採用之原料與原料明細表所提供之資料符合？請說明任何異動部份'},
                    {code:'06-3',itemSeq:'6-3', text:'6.3 原材料進貨時有驗收紀錄？驗收不合格者，有明確標示，避免誤用?'},
                    {code:'06-4',itemSeq:'6-4', text:'6.4 原料分類.離地.通風.整潔.密封放置？'},
                    {code:'06-5',itemSeq:'6-5', text:'6.5 原料依先進先出之原則處理？積存的原料未超過使用期限？生鮮原料新鮮未腐爛發霉？'},
                    {code:'06-6',itemSeq:'6-6', text:'6.6 原料各溫層儲存方式符合管控標準，並記錄?且冷凍(藏)庫未結霜?'},
                    {code:'06-7',itemSeq:'6-7', text:'6.7 製程用水水源（包含與食品直接接觸及清洗食品設備、用具之用水及冰塊）是否與申請資料描述相同？'},
                    {code:'06-8',itemSeq:'6-8', text:'6.8 製程用水之淨水處理符合規定？請說明'},
                    {code:'06-9',itemSeq:'6-9', text:'6.9 製程用水是否符合飲用水水質標準？'},
                    {code:'06-10',itemSeq:'6-10', text:'6.10 製程用水非使用自來水者，每日作有效餘氯量及酸鹼值之測定？並檢送經環保署許可之檢驗機構檢驗(微生物每年，6項重金屬兩年一次)？其測定值為何？'},
                    {code:'06-11',itemSeq:'6-11', text:'6.11 雜用水與申請資料描述相同？'},
                    {code:'06-12',itemSeq:'6-12', text:'6.12 製程用水與雜用水之管路完全分離？有做明顯標示區分？'},
                    {code:'06-13',itemSeq:'6-13', text:'6.13 使用地下水者，水源與化糞池、廢棄物、堆積場等污染源距離至少15公尺以上？'},
                    {code:'06-14',itemSeq:'6-14', text:'6.14 蓄水池（塔、槽）設置地點與化糞池、廢棄物、堆積場等污染源距離3公尺以上？'},
                    {code:'06-15',itemSeq:'6-15', text:'6.15 蓄水池（塔、槽）每年至少清洗一次並記錄？'},
                    {code:'06-16',itemSeq:'6-16', text:'6.16 使用之添加物有食品添加物許可字號或食品業者登錄平台之「產品登錄碼」？ '},
                    {code:'06-17',itemSeq:'6-17', text:'6.17 食品添加物有專櫃儲放、專人管理及專冊登錄使用？'},
                    {code:'06-18',itemSeq:'6-18', text:'6.18 食品添加物之使用符合使用範圍及限量之規定?秤量及投料有重複檢核並記錄?如有使用上限之食品添加物，請寫出該使用比例？【(該添加物重量/總原料重量)×100】'},
                    {code:'06-19',itemSeq:'6-19', text:'6.19 評鑑產品所用之原料皆有核對且與原料明細表相符?若未核對到所有原料，請說明未核對之產品名稱與原料名稱(新申請查驗與增列查驗適用)'},
                    {code:'06-others',itemSeq:'6-其他', text:'6.20 其他說明'},
                ]
            },
            {
                code:'07',text:'7.製程管理',display: '製程管理',
                items:[
                    {code:'07-1',itemSeq:'7-1', text:'7.1 實際製程與客戶所提供之資料一致？請說明任何異動部份'},
                    {code:'07-2',itemSeq:'7-2', text:'7.2 食品在製程中（含設備、器具、容器），未與地面直接接觸？'},
                    {code:'07-3',itemSeq:'7-3', text:'7.3 採取有效措施以防止金屬或外來雜物混入食品中？'},
                    {code:'07-4',itemSeq:'7-4', text:'7.4 油炸產品於製程中管控油炸用食用油之總極性化合物？請說明管理方式與檢測結果'},
                    {code:'07-5',itemSeq:'7-5', text:'7.5 於製程中有相關之管制標準？且符合管控標準？（例如：溫度、濕度、pH、水活性……）請說明管制項目、管制標準、管制結果為何？'},
                    {code:'07-6',itemSeq:'7-6', text:'7.6 測定、控制或記錄之量測器或記錄儀，應定期校正其準確性。'},
                    {code:'07-7',itemSeq:'7-7', text:'7.7 如屬於低酸性真空包裝即食性黃豆產品、低酸性及酸化罐頭食品者，其殺菌條件記錄符合中央主管機關認可機構評估之管控標準？'},
                    {code:'07-8',itemSeq:'7-8', text:'7.8 製程及品質管制有異常現象時，有矯正及防止再發生之改善措施紀錄？'},
                    {code:'07-others',itemSeq:'7-其他', text:'7.9 其他說明'},
                ]
            },
            {
                code:'08',text:'8.產品',display: '產品',
                items:[
                    {code:'08-1',itemSeq:'8-1', text:'8.1 不得回收使用之器具、容器及包裝未重複使用，得回收再使用者有經適當清潔、消毒？'},
                    {code:'08-2',itemSeq:'8-2', text:'8.2 包裝方式與包裝材質與申請資料描述相同？有符合食品器具容器包裝衛生標準之報告？'},
                    {code:'08-3',itemSeq:'8-3', text:'8.3 產品標示符合申請資料且屬實?(成分、訴求成分含量、保存方式、保存期限、原料來源宣稱..等)'},
                    {code:'08-4',itemSeq:'8-4', text:'8.4 產品標示之有效日期符合制定之保存期限？無標示不實或無未來商品？'},
                    {code:'08-5',itemSeq:'8-5', text:'8.5 品名標示原則有成分含量限制者，核對投料記錄是否符合法規規範？如：全麥麵、米粉、巧克力'},
                    {code:'08-6',itemSeq:'8-6', text:'8.6 如為自然發酵之產品，酒精含量檢測結果符合規定？檢測單位與檢測數據為何？'},
                    {code:'08-7',itemSeq:'8-7', text:'8.7 產品檢驗報告符合產品規格表？檢測項目與檢測值為何？'},
                    {code:'08-8',itemSeq:'8-8', text:'8.8 產品分類.離地.通風.整潔放置？'},
                    {code:'08-9',itemSeq:'8-9', text:'8.9 成品、半成品與原料倉庫分別設置或有作適當之區隔，能防止交叉汙染？'},
                    {code:'08-10',itemSeq:'8-10', text:'8.10 產品不合格者有加以適當處理、區隔、標示？'},
                    {code:'08-11',itemSeq:'8-11', text:'8.11 產品各溫層儲存方式符合管控標準，並記錄?冷凍(藏)庫未結霜?'},
                    {code:'08-12',itemSeq:'8-12', text:'8.12 產品有依照先進先出的原則出貨？'},
                    {code:'08-13',itemSeq:'8-13', text:'8.13 成品是否留樣保存至有效日期？'},
                    {code:'08-14',itemSeq:'8-14', text:'8.14 運輸車輛是否有運輸紀錄(車輛清潔度、車溫...)？'},
                    {code:'08-15',itemSeq:'8-15', text:'8.15 應建立產品原材料、半成品與成品供應來源及流向之追溯或追蹤系統，包含原材料進貨單/驗收單、領用/配料/投料紀錄、製程管制記錄(生產紀錄)、產品檢驗紀錄、產品入庫紀錄、產品出貨/配送記錄...等應有批號紀錄。【查驗若非單批(不同批接力)全流程查驗者，須同時確認是否達進出平衡】'},
                    {code:'08-16',itemSeq:'8-16', text:'8.16 無過去三年內（含）未曾生產之評鑑產品? 若有，請列出產品名稱，以做為延續該產品評鑑資格之參考依據。(展延查驗才須確認)'},
                    {code:'08-others',itemSeq:'8-其他', text:'8.17 其他說明'},
                ]
            },
            {
                code:'09',text:'9.標章使用', display: '標章使用',
                items:[
                    {code:'09-1',itemSeq:'9-1', text:'9.1 損毀及廢棄標章之處理方式是否予以文件化並做成紀錄?'},
                    {code:'09-2',itemSeq:'9-1', text:'9.2 是否正確使用潔淨、雙潔淨、100%無添加之標章？ '},
                    {code:'09-others',itemSeq:'9-其他', text:'9.3 其他說明'},
                ]
            },
        ]
    }
]

export  default checklists;